import { format, utcToZonedTime } from 'date-fns-tz';

import Constants from '@/util/constants'
import Store from '@/store'

const Util = {
  emptyFn() {

  },

  isEmpty(obj) {
    if (obj === 0) return false
    if (!obj) return true
    if (Array.isArray(obj) && obj.length === 0) {
      return true
    } else if (typeof obj === 'object' && Object.keys(obj).length === 0) {
      return true
    } else if (typeof obj === 'string' && obj.trim().length === 0) {
      return true
    }
    return false
  },

  arrayToMap(array, id) {
    if (Util.isEmpty(array)) {
      return null
    }

    return array.reduce((map, obj) => {
      map[obj[id]] = obj
      return map
    }, {})
  },

  cloneObj(obj) {
    return JSON.parse(JSON.stringify(obj))
  },

  groupBy(array, key) {
    const result = {}
    array.forEach(item => {
      if (!result[item[key]]) {
        result[item[key]] = []
      }
      result[item[key]].push(item)
    })
    return result
  },

  arrayToKeyValArr(array, key) {
    const result = {}
    array.forEach(item => {
      result[item[key]] = item
    })
    return result
  },

  insertDecimalPoints(number) {
    var exp = /\d(?=(\d{3})+\.)/g
    var res

    if (isNaN(number)) {
      return '0.00'
    }
    if (number % 1 === 0) {
      res = Math.abs(number).toFixed(2).replace(exp, '$&,')
    } else if (number.toString().split('.')[1].length < 3) {
      res = Math.abs(number).toFixed(2).replace(exp, '$&,')
    } else {
      res = Math.abs(number).toString().replace(exp, '$&,')
    }
    if (number < 0) {
      res = '-' + res
    }
    return res
  },

  isEmail(email) {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return regex.test(email)
  },

  isPhoneNumber(num) {
    const regex = /^[6-9]\d{9}$/

    return regex.test(num)
  },

  convertNamValToObj(array, param) {
    return array.reduce((map, obj) => {
      map[obj[param.name]] = obj[param.value]
      return map
    }, {})
  },

  pluck(array, key) {
    const keyPluckFromArr = (obj, k) => {
      if (Array.isArray(k)) {
        if (k.length > 1) {
          return keyPluckFromArr(obj[k[0]], k.slice(1))
        }
        return obj[k[0]]
      }
      return obj[k]
    }

    return array.map(obj => keyPluckFromArr(obj, key))
  },

  convertToDate(timeStr) {
    let d = new Date()

    d.setHours(timeStr.hh)
    d.setMinutes(timeStr.mm)

    return d
  },

  formatDate(params = {}) {
    let date = new Date();
    if (params.date) {
      if (params.date instanceof Date) {
        date = params.date;
      } else {
        date = new Date(params.date);
      }
    }

    let datePattern = params.pattern || 'd MMM Y';
    if (params.zoneId) {
      datePattern = 'yyyy-MM-dd\'T\'HH:mm:ssxxx';
      return format(utcToZonedTime(date, params.zoneId), datePattern, { timeZone: params.zoneId });
    }

    return format(date, datePattern);
  },

  unique(arr) {
    return arr.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
  },

  removeArrFalsyVal(arr) {
    return arr.filter(function (v) { return !!v; })
  },

  removeFalsyValues(obj) {
    for (let i in obj) {
      if (typeof obj[i] === 'object') {
        this.removeFalsyValues(obj[i]);
      }
      if (obj[i] === null || obj[i] === undefined || this.isEmpty(obj[i])) {
        delete obj[i];
      }
    }
    return obj;
  },

  isMobile() {
    const regEx = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
    // eslint-disable-next-line
    const regEx2 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
    const ua = navigator.userAgent || navigator.vendor || window.opera
    return ua.split(' ').some(a => regEx.test(a) || regEx2.test(a.substr(0, 4)))
  },

  parseAddress(results, me) {
    const mapping = {
      zip: "postal_code",
      city: "locality",
      state: "administrative_area_level_1",
      country: "country",
      countryCode: "country",
      a0: "establishment",
      a1: "room",
      a2: "post_box",
      a3: "floor",
      a4: "premise",
      a5: "subpremise",
      a6: "street_number",
      a7: "street_address",
      a8: "route",
      a9: "neighborhood",
      a10: "sublocality_level_5",
      a11: "sublocality_level_4",
      a12: "sublocality_level_3",
      a13: "sublocality_level_2",
      a14: "sublocality_level_1"
    };
    const entity = results[0];

    let tmp = {};
    let al = "";
    Object.keys(mapping).forEach(function (key) {
      let add;
      for (let i = 0, n = entity.address_components.length; i < n; i += 1) {
        add = entity.address_components[i] || {};
        add.types = add.types || [];
        if (add.types.indexOf(mapping[key]) > -1) {
          if (key.charAt(0) === "a") {
            tmp[key] = add.long_name;
          } else if (key === "countryCode") {
            me[key] = add.short_name;
          } else {
            me[key] = add.long_name;
          }
          break;
        }
      }
    });

    for (let i = 0, n = 14; i <= n; i += 1) {
      if (tmp["a" + i]) {
        al = al + tmp["a" + i] + ", ";
      }
    }

    if (al.length > 0) {
      me.addressLine = al.substr(0, al.length - 2);
    }

    var start = me.addressLine.substr(0, 5);
    if (entity.formatted_address.indexOf(start) > 0) {
      me.addressLine =
        entity.formatted_address.substr(
          0,
          entity.formatted_address.indexOf(start)
        ) + me.addressLine;
    }
  },

  formatPrice(number) {
    if (isNaN(number)) {
      return ''
    }
    const curr = Constants.currency[Store.getters['business/currency']]

    return [curr, this.insertDecimalPoints(number)].join(' ')
  },

  displayPrice(number) {
    if (isNaN(number)) {
      return ''
    }
    const currCode = Store.getters['business/currency'] || 'INR'
    const curr = Constants.currency[currCode]

    return [curr, Math.round(number)].join(' ')
  },

  isValidPhoneNumber(phoneNumber) {
    if (!phoneNumber ||
      phoneNumber.length !== 10 ||
      isNaN(phoneNumber)
    ) {
      return false;
    }
    return true;
  },

  isValidName(name = '') {
    const nameRE = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
    if (name.trim().length === 0 || !nameRE.test(name)) {
      return false;
    }
    return true;
  },

  notify(context, params) {
    if (!context || !params || !(params.error || params.message)) return;

    let text = params.message;
    if (params.error) {
      text = params.error.message || params.error.msg || params.error.code || params.error;
    }

    context.$notify({
      group: 'toast',
      type: params.type || 'error',
      text,
      duration: params.sticky ? -100 : 2000
    });
  },

  concatArr(arr) {
    let out = [].concat.apply([], arr);

    return Util.removeArrFalsyVal(out);
  },

  isValidPrice(price) {
    return !Util.isEmpty(price) || price === 0
  }
}

export default Util
